import { render, staticRenderFns } from "./InputMinusPlus.vue?vue&type=template&id=0895a870&"
import script from "./InputMinusPlus.vue?vue&type=script&lang=js&"
export * from "./InputMinusPlus.vue?vue&type=script&lang=js&"
import style0 from "./InputMinusPlus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports